/**
 * Caracteres válidos para números de teléfono
 */
export const VALID_PHONE_CHARACTERS = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "0",
  "+",
  "-",
  " ",
  "(",
  ")"
];
